export default __webpack_public_path__ + "static/media/ID_SCHOOL_PROF PASCAL.0b30080d.jpg";